export const mostSearchedStocks = [
   {
      "heading": "US Stocks",
      "data": [
         { "title": "Is Nvidia Halal Stock", "url": "/stock/NVDA/" },
         { "title": "Is Apple Halal Stock", "url": "/stock/AAPL/" },
         { "title": "Is Google Halal Stock", "url": "/stock/GOOGL/" },
         { "title": "Is Microsoft Halal Stock", "url": "/stock/MSFT/" },
         { "title": "Is Amazon Halal Stock", "url": "/stock/AMZN/" },
         { "title": "Is Facebook Halal Stock", "url": "/stock/META/" },
         { "title": "Is Broadcom Halal Stock", "url": "/stock/AVGO/" },
         { "title": "Is Tesla Halal Stock", "url": "/stock/TSLA/" },
         { "title": "Is Berkshire Hathway Halal Stock", "url": "/stock/BRK.B/" },
         { "title": "Is Walmart Halal Stock", "url": "/stock/WMT/" },
         { "title": "Is JP Morgan Halal Stock", "url": "/stock/JPM/" },
         { "title": "Is Exonn Mobil Halal Stock", "url": "/stock/XOM/" },
         { "title": "Is Oracle Halal Stock", "url": "/stock/ORCL/" },
         { "title": "Is Mastercard Halal Stock", "url": "/stock/MA/" },
         { "title": "Is Palantir Halal Stock", "url": "/stock/PLTR/" }
      ]
   },
   {
      "heading": "India Stocks",
      "data": [
         { "title": "Is Reliance Industries Halal Stock", "url": "/stock/RELIANCE.NS/" },
         { "title": "Is Airtel Halal Stock", "url": "/stock/BHARTIARTL.NS/" },
         { "title": "Is TCS Halal Stock", "url": "/stock/TCS.NS/" },
         { "title": "Is Infosys Halal Stock", "url": "/stock/INFY.NS/" },
         { "title": "Is Larsen & Tourbo Halal Stock", "url": "/stock/LT.NS/" },
         { "title": "Is Sun Pharma Halal Stock", "url": "/stock/SUNPHARMA.NS/" },
         { "title": "Is Maruti Suzuki Halal Stock", "url": "/stock/MARUTI.NS/" },
         { "title": "Is ITC Halal Stock", "url": "/stock/ITC.NS/" },
         { "title": "Is NTPC Halal Stock", "url": "/stock/NTPC.NS/" },
         { "title": "Is HCL Tech Halal Stock", "url": "/stock/HCLTECH.NS/" },
         { "title": "Is Titan Halal Stock", "url": "/stock/TITAN.NS/" },
         { "title": "Is ONGC Halal Stock", "url": "/stock/ONGC.NS/" },
         { "title": "Is BEL Halal Stock", "url": "/stock/BEL.NS/" },
         { "title": "Is Ultratech Cement Halal Stock", "url": "/stock/ULTRACEMCO.NS/" },
         { "title": "Is Coal India Halal Stock", "url": "/stock/COALINDIA.NS/" }
      ]
   },
   {
      "heading": "UK Stocks",
      "data": [
         { "title": "Is AstraZeneca Halal Stock", "url": "/stock/AZN.L/" },
         { "title": "Is Shell Halal Stock", "url": "/stock/SHEL.L/" },
         { "title": "Is Linde Halal Stock", "url": "/stock/LIN/" },
         { "title": "Is Rio Tinto Halal Stock", "url": "/stock/RIO.L/" },
         { "title": "Is Rolls Royce Halal Stock", "url": "/stock/RR.L/" },
         { "title": "Is Arm Holdings Halal Stock", "url": "/stock/ARM/" },
         { "title": "Is GSK Halal Stock", "url": "/stock/GSK.L/" },
         { "title": "Is BAE Systems Halal Stock", "url": "/stock/BA.L/" },
         { "title": "Is National Grid Halal Stock", "url": "/stock/NG.L/" },
         { "title": "Is Barclays Halal Stock", "url": "/stock/BARC.L/" },
         { "title": "Is Aon Halal Stock", "url": "/stock/AON/" },
         { "title": "Is NatWest Group Halal Stock", "url": "/stock/NWG.L/" },
         { "title": "Is Relx Halal Stock", "url": "/stock/REL.L/" },
         { "title": "Is London Stock Exchange Halal Stock", "url": "/stock/LSEG.L/" },
         { "title": "Is Compass Group Halal Stock", "url": "/stock/CPG.L/" }
      ]
   },
   {
      "heading": "Canada Stocks",
      "data": [
         { "title": "Is Shopify Halal Stock", "url": "/stock/SHOP.TO/" },
         { "title": "Is Enbridge Halal Stock", "url": "/stock/ENB.TO/" },
         { "title": "Is Agnico Eagle Halal Stock", "url": "/stock/AEM.TO/" },
         { "title": "Is Brookfield Corp Halal Stock", "url": "/stock/BN.TO/" },
         { "title": "Is Barrick Gold Halal Stock", "url": "/stock/B/" },
         { "title": "Is Brookfield Asset Management Halal Stock", "url": "/stock/BAM.TO/" },
         { "title": "Is Suncor Energy Halal Stock", "url": "/stock/SU.TO/" },
         { "title": "Is Wheaton Precious Metals Halal Stock", "url": "/stock/WPM.TO/" },
         { "title": "Is TC Energy Halal Stock", "url": "/stock/TRP.TO/" },
         { "title": "Is Canadian National Railway Halal Stock", "url": "/stock/CNR.TO/" },
         { "title": "Is Imperial Oil Halal Stock", "url": "/stock/IMO.TO/" },
         { "title": "Is Loblaw Companies Halal Stock", "url": "/stock/L.TO/" },
         { "title": "Is Cameco Halal Stock", "url": "/stock/CCO.TO/" },
         { "title": "Is Thompson Reuters Halal Stock", "url": "/stock/TRI.TO/" },
         { "title": "Is Cenovus Energy Halal Stock", "url": "/stock/CVE.TO/" }
      ]
   },
   {
      "heading": "UAE Stocks",
      "data": [
         { "title": "Is International Holding Halal Stock", "url": "/stock/IHC.AD/" },
         { "title": "Is Taqa Halal Stock", "url": "/stock/TAQA.AD/" },
         { "title": "Is Adnoc Gas Halal Stock", "url": "/stock/ADNOCGAS.AD/" },
         { "title": "Is First Abu Dhabi Bank Halal Stock", "url": "/stock/FAB.AD/" },
         { "title": "Is Emirates Telecom Halal Stock", "url": "/stock/EAND.AD/" },
         { "title": "Is Dewa Halal Stock", "url": "/stock/DEWA.DB/" },
         { "title": "Is Emaar Properties Halal Stock", "url": "/stock/EMAAR.DB/" },
         { "title": "Is Alpha Dhabi Halal Stock", "url": "/stock/ALPHADHABI.AD/" },
         { "title": "Is Abu Dhabi Islamic Bank Halal Stock", "url": "/stock/ADIB.AD/" },
         { "title": "Is Adnoc Drilling Company Halal Stock", "url": "/stock/ADNOCDRILL.AD/" },
         { "title": "Is Borouge Halal Stock", "url": "/stock/BOROUGE.AD/" },
         { "title": "Is Multiple Group Halal Stock", "url": "/stock/MULTIPLY.AD/" },
         { "title": "Is Al Dar Properties Halal Stock", "url": "/stock/ALDAR.AD/" },
         { "title": "Is Emaar Development Halal Stock", "url": "/stock/EMAARDEV.DB/" },
         { "title": "Is Dubai Islamic Bank Halal Stock", "url": "/stock/DIB.DB/" }
      ]
   }
]

export const mostSearchETFs = [
   {
      "heading": "US ETFs",
      "data": [
         { "title": "Is Vanguard S&P 500 ETF Halal", "url": "/etf/VOO/" },
         { "title": "Is iShares Core S&P 500 ETF Halal", "url": "/etf/IVV/" },
         { "title": "Is SPDR S&P 500 ETF Halal", "url": "/etf/SPY/" },
         { "title": "Is Vanguard Total Stock Market Index Fund ETF Halal", "url": "/etf/VTI/" },
         { "title": "Is Invesco QQQ Trust Halal", "url": "/etf/QQQ/" },
         { "title": "Is Vanguard Growth Index Fund ETF Shares Halal", "url": "/etf/VUG/" },
         { "title": "Is Vanguard Value Index Fund ETF Shares Halal", "url": "/etf/VTV/" },
         { "title": "Is iShares Russell 1000 Growth ETF Halal", "url": "/etf/IWF/" },
         { "title": "Is State Street SPDR Portfolio S&P 500 ETF Halal", "url": "/etf/SPLG/" },
         { "title": "Is Schwab U.S. Dividend Equity ETF Halal", "url": "/etf/SCHD/" }
      ]
   },
   {
      "heading": "India ETFs",
      "data": [
         { "title": "Is iShares MSCI India ETF Halal", "url": "/etf/INDA/" },
         { "title": "Is iShares MSCI India UCITS ETF USD Acc Halal", "url": "/etf/IIND.L/" },
         { "title": "Is Franklin FTSE India ETF Halal", "url": "/etf/FLIN/" },
         { "title": "Is WisdomTree India Earnings Fund Halal", "url": "/etf/EPI/" },
         { "title": "Is Franklin FTSE India UCITS ETF Halal", "url": "/etf/FLIN.L/" },
         { "title": "Is Amundi MSCI India II UCITS ETF EUR Acc Halal", "url": "/etf/CI6.L/" },
         { "title": "Is iShares India 50 ETF Halal", "url": "/etf/INDY/" },
         { "title": "Is Invesco India ETF Halal", "url": "/etf/PIN/" },
         // { "title": "Is Nippon India ETF Nifty 50 BeES Halal", "url": "/stock/NIFTYBEES.NS/" },
         // { "title": "Is Nippon India ETF Gold BeES Halal", "url": "/stock/GOLDBEES.NS/" }
      ]
   }
]